import React, { useState } from "react";
import KnowUsModal from "./KnowUsModal";

const Footer: React.FC = () => {
  const [isKnowUsModalOpen, setIsKnowUsModalOpen] = useState(false);

  return (
    <footer className="bg-gray-900 text-white py-8 mt-auto">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <div className="flex items-center justify-center space-x-2 mb-4">
            {/* Logo Icon */}
            <div className="relative">
              <svg 
                className="w-8 h-8 text-white" 
                viewBox="0 0 32 32" 
                fill="currentColor"
              >
                {/* Main star shape */}
                <path d="M16 2L19.09 11.26L28 12L19.09 12.74L16 22L12.91 12.74L4 12L12.91 11.26L16 2Z" />
                {/* Inner sparkle */}
                <path d="M16 8L17.5 12.5L22 14L17.5 15.5L16 20L14.5 15.5L10 14L14.5 12.5L16 8Z" fill="rgba(255,255,255,0.3)" />
              </svg>
            </div>
            <span className="text-xl font-bold">Startup Worth</span>
          </div>
          
          {/* Services */}
          <div className="text-sm text-gray-300 mb-4 max-w-4xl mx-auto leading-relaxed">
            <span className="font-medium text-white">Our Services:</span> Startup Valuation & Fundraising Suite | Investor-Ready Documents | Due Diligence & Compliance Support | ESOP & Equity Structuring Tools & more..
          </div>
          
          {/* Know Us Link */}
          <div className="mb-4">
            <button
              onClick={() => setIsKnowUsModalOpen(true)}
              className="text-purple-400 hover:text-purple-300 text-sm font-medium underline transition-colors"
            >
              Know Us
            </button>
          </div>
          
          {/* Copyright */}
          <div className="text-xs text-gray-400 border-t border-gray-700 pt-4">
            © 2024 Startup Worth. All rights reserved.
          </div>
        </div>
      </div>
      
      {/* Know Us Modal */}
      <KnowUsModal 
        isOpen={isKnowUsModalOpen} 
        onClose={() => setIsKnowUsModalOpen(false)} 
      />
    </footer>
  );
};

export default Footer;
